import { ChaveValorStrInterface } from "../util/chave-valor-str-interface";
import { Util } from "../util/util";

export class HistoricoEvento {

    id: number = 0;

    data: Date = new Date();

    usuario: string = '';

    evento: string = '';

    menu: string = '';

    complemento: string = '';

    eventoFormatado: string = '';

    menuFormatado: string = '';

    constructor() {

    }

    static fromClasse(historicoEvento: HistoricoEvento): HistoricoEvento {

        var novoHistoricoEvento: HistoricoEvento = new HistoricoEvento();

        novoHistoricoEvento.id = historicoEvento.id;

        novoHistoricoEvento.data = historicoEvento.data;

        novoHistoricoEvento.usuario = historicoEvento.usuario;

        novoHistoricoEvento.evento = historicoEvento.evento;

        novoHistoricoEvento.menu = historicoEvento.menu;

        novoHistoricoEvento.complemento = historicoEvento.complemento;

        novoHistoricoEvento.eventoFormatado = this.getTextoFormatado(historicoEvento.evento, Util.listaEventosSistema);

        novoHistoricoEvento.menuFormatado = this.getTextoFormatado(historicoEvento.menu, Util.listaMenusSistema);

        return novoHistoricoEvento;
    }

    private static getTextoFormatado(texto: string, lista: ChaveValorStrInterface[]): string {
        if (texto) {
            return lista.filter(evt => evt.codigo === texto)[0].descricao;
        }

        return '';
    }
}
